// This file contains configuration data for various announcements to be displayed on the website.

// load proptypes if this runs before app inits
if (!window.PropTypes) {
    window.PropTypes = require("prop-types");
    window.StrictPropTypes = require("airbnb-prop-types").forbidExtraProps;
}

var Glyphicon = require("components/utility/icons/Glyphicon");
var SlideInAnnouncement = require("components/notifications/SlideInAnnouncement")
var NewItemsModal = require("components/games/NewItemsModal")
var NewFeaturesModal = require("components/notifications/new_features/NewFeaturesModal")
var SiteAnnoucementModal = require("components/notifications/SiteAnnoucementModal")

// This section defines keys for the different types of announcements that can be displayed on the website
// These keys are used to identify the specific announcement in the configuration object
// It is important that the keys match the announcement_key in the data hash coming from the l2e announcement
export var LANDING_PAGE_PROMO = "landing_page_promo"
export var OWLSHOP_UPDATE = "owlshop_update"
export var NEW_FEATURES = "new_features"
export var ACQUISITION_ANNOUCEMENT = "acquisition_announcement"
export var SITE_DOWNTIME = "site_downtime"

// To add a new announcement, follow the existing pattern and add a new entry to the CONFIG object
// Be sure to include a unique key for the announcement and specify the launch date, description, trigger, and component to be used
// The trigger specifies when the announcement should be displayed based on the user's role and current path
// The component specifies the React component to be used for displaying the announcement
// If additional props are needed for the component, they can be added to the props object
export var CONFIG = {
    [LANDING_PAGE_PROMO]: {
        launch_date: new Date("2022-11-22"),
        expo_date: null,
        description: 'Promotes teachers to share WR landing page with admins',
        trigger:
        {
            paths: ["/"],
            conditions: (user) => {
                return user.role == 'teacherRole' && waitForElm('.allWidgets').then(() => {
                    // prevent conflicts from survey prompts
                    return $(document.getElementsByClassName('surveyPromptContainer')).length == 0

                });
            }
        },
        component: SlideInAnnouncement,
        props: {
            bodyContent: (
                <div className="bodyContent">
                    <p><span className='blueText'>Whooo's Reading</span> is better when you upgrade!</p>
                    <p>Share this link with your admin so they can learn more and watch a demo:</p>
                    <p className={'cta blueText'} onClick={() => {
                        navigator.clipboard.writeText('www.whooosreading.org/learnmore');
                        window.wrNotifications.triggerDropDownNotification({
                            title: "Copied!", text: 'The link was copied to your clipboard', icon: "link"
                        });
                    }}>
                        Copy Link <Glyphicon icon={'link'} className={'link'} />
                    </p>
                </div>
            )
        }
    },
    [OWLSHOP_UPDATE]: {
        launch_date: new Date("2023-01-01"),
        expo_date: null,
        description: 'Promotes Owlshop Updates',
        trigger:
        {
            paths: ["/"],
            conditions: (user) => {
                return user.role == 'studentRole'
            }
        },
        component: NewItemsModal,
        props: {
            title: `🚨🚨 New Owl Shop Items Alert 🚨🚨`,
            open: true
        }
    },
    [NEW_FEATURES]: {
        launch_date: new Date("2023-03-01"),
        expo_date: null,
        description: 'Promotes New Features',
        trigger:
        {
            paths: ["/"],
            conditions: (user) => {
                return user.role != 'studentRole'
            }
        },
        component: NewFeaturesModal,
        props: {}
    },
    [ACQUISITION_ANNOUCEMENT]: {
        launch_date: new Date("2023-03-28"),
        expo_date: null,
        description: 'Displays Acquisition Announcement',
        trigger:
        {
            paths: ["/"],
            conditions: (user) => {
                return user.role != 'studentRole'
            }
        },
        component: SiteAnnoucementModal,
        props: {
            title: `Savvas Learning Company Acquires Whooo's Reading`,
            titleImage: 'logos/savvas-logo.jpg',
            bodyContent: (
                <div>
                    <div className="titleImgeContainer">
                        <img className='savvasLogo titleImage' src={dynamicRequire('logos/savvas-logo.jpg')} />
                        <img className='wrLogo titleImage' src={dynamicRequire('logos/wr-logo.png')} />
                    </div>
                    <p>We are excited to share with you the <a href='https://www.savvas.com/index.cfm?locator=PS3mXi' target='_blank'>news</a> that Whooo's Reading has been acquired by <a href='https://www.savvas.com/' target='_blank' >Savvas Learning Company</a>.</p>
                    <p><strong>First things first</strong> - Your access to the Whooo's Reading program will not be changing, and the entire Whooo's Reading team has joined Savvas, so you can continue to connect with us the same way you always have.</p>
                    <p><strong>Now the exciting part</strong> - Teaming up with Savvas gives us the opportunity to advance our machine-learning technology, allowing us to support schools in providing the most advanced personalized learning for students. This could lead to more accurate and robust rubric-driven evaluations of your students' written responses, more personalized in-the-moment feedback for your students, and more actionable data to support your instruction.</p>
                    <p>We are eager to continue working with you and striving to provide the most personalized and engaging learning experience for your students.</p>
                </div>
            ),
        }
    },
    [SITE_DOWNTIME]: {
        launch_date: new Date("2023-12-01"),
        expo_date: null,
        description: 'Displays Site Downtime Announcement',
        trigger:
        {
            paths: ["/"],
            conditions: (user) => {
                return true
            }
        },
        component: SiteAnnoucementModal,
        props: {
            title: `🚨 Website Downtime for Maintenance 🚨`,
            bodyContent: (
                <div>
                    <p>We would like to inform you that our website will be temporarily unavailable for essential maintenance work. To ensure a seamless user experience, we will be conducting this maintenance for approximately four days. We apologize for any inconvenience caused and appreciate your understanding.</p>
                    <p>Maintenance Schedule:</p>
                    <ul>
                        <li>Start Date: <strong>December 19, 2023, at 12 am EST</strong></li>
                        <li>End Date: <strong>December 21, 2023, at 12 am EST</strong></li>
                    </ul>
                    <p>During the maintenance period:</p>
                    <ul>
                        <li>The website will be inaccessible.</li>
                        <li>User accounts and data will remain secure.</li>
                        <li>New registrations, logins, and transactions will be temporarily disabled.</li>
                        <li>Any changes made to your account before the maintenance will be saved.</li>
                    </ul>
                    <p>If you have any questions, please email us at <strong>support@whooosreading.org</strong>, and we would be very happy to help you!</p>
                    <p>Thank you for your understanding and support.</p>
                    <p>Sincerely,</p>
                    <p>Whooo's Reading</p>
                </div>
            ),
        }
    }
}

// This function shows an announcement on the website if the conditions specified in the configuration object are met
export function showAnnouncement(path, alert, user) {
    if (!alert || !('annoucement_key' in alert.data)) { return null }

    var key = alert.data['annoucement_key']
    var config = CONFIG[key]
    // check key exists
    if (!config) { return null }

    // check expo date
    if (config.expo_date && config.expo_date < new Date()) { return null }

    // check path
    if (!_.includes(config.trigger.paths, path)) { return null }

    // check conditions
    if (!config.trigger.conditions(user)) { return null }

    var props = { ...config.props, alertID: alert.id }

    return <config.component key={alert.id} {...props} />
}

///// HELPERS /////
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


// WEBPACK FOOTER //
// ./modules/lib/notifications/AnnouncementsConfig.js